import { Component } from '@angular/core';
@Component({
  selector: 'rh-global-settings-container',
  templateUrl: './global-settings.container.html',
  styleUrls: ['./global-settings.container.scss']
})
export class GlobalSettingsContainer {
  constructor() {}
}
